exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n\n/* Sync for Science Discovery HighlightDiv Stylesheet */\n\n/* v.01.01 Updated 09/14/2019 */\n\n.highlight-resource {\n   background-color: var(--tile-selected);\n}\n\n.highlight-resource-last {\n   background-color: var(--tile-selected-last);\n   display: flex;\n   \n   border-radius: 3px;\n}\n\n", ""]);

// exports
